import { IKeyValue } from './breast-cancer-calc-interfaces';
export const historicalGrade = [
  '',
  'I',
  'II',
  'III'
];

export const posAndNegList = [
  'EMPTY',
  'POSITIVE',
  'NEGATIVE'
];

export const KI67 = [
  '',
  '≥20%',
  '<20%'
];


export const stages = [
  '', '0', 'IA', 'IB', 'IIA', 'IIB', 'IIIA', 'IIIB', 'IIIC', 'IV'
];

export const molecularTypeList = [
  'LA',
  'LB',
  'HER2',
  'BASAL',
  'CLAUDIN',
  'NOTAVAILABLE',
];
export const histologyTypeList = [
  'DINSITU',
  'DINFILTRATING',
  'DTUBULAR',
  'DMUCINOUS',
  'DMEDULLARY',
  'LINSITU',
  'LINFILTRATING',
  'NOTAVAILABLE',
];

export const metastesesOptions: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'M0',
    value: 'M0'
  },
  {
    key: 'M1',
    value: 'M1'
  },
  {
    key: 'Mx',
    value: 'Mx'
  }
];

export const nodalInvolvementOptions: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'N0',
    value: 'N0'
  },
  {
    key: 'N1',
    value: 'N1'
  },
  {
    key: 'N1mi',
    value: 'N1mi'
  },
  {
    key: 'N2',
    value: 'N2'
  },
  {
    key: 'N3',
    value: 'N3'
  },
  {
    key: 'Nx',
    value: 'Nx'
  }
];
export const breastCancerTNM: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'Tis',
    value: 'Tis'
  },
  {
    key: 'T0',
    value: 'T0'
  },
  {
    key: 'T1',
    value: 'T1'
  },
  {
    key: 'T2',
    value: 'T2'
  },
  {
    key: 'T3',
    value: 'T3'
  },
  {
    key: 'T4',
    value: 'T4'
  },
  {
    key: 'Tx',
    value: 'Tx'
  }
];
